<template>
    <div>
        <!-- 面包屑 -->
        <breadcrumbs></breadcrumbs>
        <!-- 查询条件 -->
        <div class="pdt-15  bg-white">
            <el-form ref="searchForm" :model="searchForm" label-width="100px" inline class="demo-form-inline"
                size='small'>
                <el-form-item label="产品名称" prop="productName">
                    <el-input v-model="searchForm.productName" clearable placeholder="请输入产品名称"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getProductList">查询</el-button>
                    <el-button @click="handleReset">重置</el-button>
                    <el-button @click="dingdanjilu">订单记录</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="mgt-15 pdt-15 pdb-15 bg-white" >
            <div class="navbox" v-if="productList.length > 0">
                <!-- 修改：在v-for中添加index参数 -->
                <div class="navitem" v-for="(value, index) in productList" :key="value.id">
                    <div class="navitem_type" v-if="value.type === 2">专属特价</div>
                    <div class="navitem_type navitem_type_trial" v-else-if="value.type === 3">试用</div>
                    <div class="navitem_top">
                        <div class="navitem_video">
                            <!-- <video :src="value.video" controls></video> -->
                            <video :src="value.video" class="custom-video" controls controlsList="nodownload"
                                disablePictureInPicture @mouseover="pauseVideo" @mouseout="pauseVideo"
                                @click="playVideo(value.video)"></video>
                        </div>
                        <div class="navitem_info">
                            <div class="flex ">
                                <div>
                                    产品名称：
                                </div>
                                <div>
                                    {{ value.productName }}
                                </div>
                            </div>
                            <div class="flex mgt-10">
                                <div>
                                    产品有效期：
                                </div>
                                <div>
                                    {{ value.validityPeriod }}
                                </div>
                            </div>
                            <!-- <div class="flex mgt-10">
                                <div>
                                    标准价格：
                                </div>
                                <div class="line-through">
                                    {{ value.price + 200 }}
                                </div>
                            </div> -->
                            <div class="flex mgt-10 aife">
                                <div>
                                    专属价格：
                                </div>
                                <!-- 给文字加中横线 -->
                                <div class="new_price">
                                    {{ value.price }}
                                </div>
                            </div>
                            <div class="flex mgt-10" v-if="value.type === 2">
                                <div>
                                    特价倒计时:
                                </div>
                                <div class="daojishi_time">
                                    {{ value.countdownText }}
                                </div>
                            </div>

                        </div>
                        <div class="navitem_buy">
                            <el-button type="primary" @click="buyProduct(value)">购买</el-button>
                        </div>
                    </div>
                    <div class="navitem_bottom">
                        <div class="fcolo0065A3">
                            产品介绍:
                        </div>
                        <div class="navitem_bottom_text">
                            <div class="content-wrapper">
                                <!-- 一行显示，超出隐藏 -->
                                <span :ref="`contentText_${index}`" class="content-text"
                                    :class="{ 'show-full': getShowFullContent(index) }">
                                    {{ value.description || '暂无介绍' }}
                                </span>

                                <!-- 查看更多按钮（当内容超出一行时显示） -->
                                <el-button v-if="getIsOverflow(index) && !getShowFullContent(index)" type="text"
                                    size="mini" @click="showDetailDialog(value, index)" class="view-more-btn">
                                    查看更多
                                </el-button>

                                <!-- 收起按钮（展开状态下显示） -->
                                <el-button v-if="getIsOverflow(index) && getShowFullContent(index)" type="text"
                                    size="mini" @click="toggleContent(index)" class="view-less-btn">
                                    收起
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="fcolo0065A3">
                    暂无数据
                </div>
            </div>
        </div>



        <!-- 弹窗显示完整内容 -->
        <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" width="50%">
            <div class="detail-content">
                {{ currentContent }}
            </div>
            <span slot="footer">
                <el-button @click="detailDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="宣传视频" :visible.sync="videoVisible" width="800px">
            <video :src="currentVideoUrl" controls width="100%" height="450px"></video>
            <div slot="footer" class="dialog-footer">
                <el-button @click="videoVisible = false">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
    components: {
        breadcrumbs,
        btns,
    },
    data() {
        return {
            searchForm: {
                name: '',
            },
            productList: [],
            contentStates: [], // 存储每个产品的展开状态
            detailDialogVisible: false,
            detailDialogTitle: '产品详情',
            currentContent: '', // 当前弹窗显示的内容
            videoVisible: false, // 视频弹窗是否可见
            currentVideoUrl: '', // 当前播放的视频URL
            countdownTimers: [] // 存储所有计时器的ID
        }
    },
    mounted() {
        this.getProductList();
    },
    watch: {
        // 监听产品列表变化，初始化内容状态
        productList: {
            handler(newList) {
                if (newList && newList.length > 0) {
                    // 为每个产品初始化状态
                    this.contentStates = newList.map(() => ({
                        isOverflow: false,
                        showFullContent: false
                    }));

                    // 在下一次DOM更新后检查溢出
                    this.$nextTick(() => {
                        this.checkAllTextOverflow();
                    });
                }
            },
            immediate: false
        }
    },
    methods: {
        // 安全获取是否溢出状态
        getIsOverflow(index) {
            return this.contentStates[index] && this.contentStates[index].isOverflow;
        },

        // 安全获取是否显示完整内容状态
        getShowFullContent(index) {
            return this.contentStates[index] && this.contentStates[index].showFullContent;
        },

        // 检查所有文本是否溢出
        checkAllTextOverflow() {
            if (!this.productList || this.productList.length === 0) return;

            this.productList.forEach((item, index) => {
                this.$nextTick(() => {
                    this.checkTextOverflow(index);
                });
            });
        },

        // 检查单个文本是否溢出
        checkTextOverflow(index) {
            const contentElement = this.$refs[`contentText_${index}`];
            if (contentElement && contentElement[0]) {
                const element = contentElement[0];
                // 检查元素的实际高度是否大于一行的高度
                const lineHeight = parseInt(getComputedStyle(element).lineHeight);
                const actualHeight = element.scrollHeight;

                // 更新该元素的状态
                this.$set(this.contentStates, index, {
                    ...this.contentStates[index],
                    isOverflow: actualHeight > lineHeight * 1.5
                });
            }
        },

        // 显示详情弹窗
        showDetailDialog(item, index) {
            this.currentContent = item.description || '';
            this.detailDialogTitle = `${item.productName} - 产品介绍`;
            this.detailDialogVisible = true;
        },

        // 切换展开/收起状态
        toggleContent(index) {
            if (this.contentStates[index]) {
                this.$set(this.contentStates, index, {
                    ...this.contentStates[index],
                    showFullContent: !this.contentStates[index].showFullContent
                });
            }
        },

        getProductList() {
            this.$api.valueAddedService.getProductList({ name: this.searchForm.productName }).then((res) => {
                console.log('获取产品列表', res)
                if (res.code === 200) {
                    // this.productList = res.data.rows || [];
                    const rows = res.data.rows || [];
                    // const rows =  [];

                    // 根据 type 进行排序：3排在最前，2排中间，1排在最后
                    this.productList = rows.sort((a, b) => {
                        // 定义排序优先级：type=3 > type=2 > type=1
                        const priority = {
                            2: 1, // 最高优先级
                            3: 2, // 中等优先级
                            1: 3  // 最低优先级
                        };

                        // 如果 type 不在优先级列表中，默认给最低优先级
                        const aPriority = priority[a.type] || 999;
                        const bPriority = priority[b.type] || 999;

                        return aPriority - bPriority;
                    });
                    // 初始化倒计时
                    this.initCountdowns();
                } else {
                    handleAlert(res.msg || '获取产品列表失败', 'error');
                    this.productList = [];
                }
            }).catch((error) => {
                console.error('获取产品列表失败:', error);
                handleAlert('获取产品列表失败', 'error');
                this.productList = [];
            });
        },
        // 初始化所有倒计时
        initCountdowns() {
            // 先清除之前的计时器
            this.clearAllCountdowns();

            // 为每个有expireTime的产品启动倒计时
            this.productList.forEach((product, index) => {
                if (product.expireTime) {
                    this.startCountdown(product, index);
                }
            });
        },
         // 启动单个产品的倒计时
    startCountdown(product, index) {
        // 设置结束时间为当天的23:59:59
        const endDate = this.getEndTime(product.expireTime);
        
        // 更新倒计时显示
        const updateCountdown = () => {
            const now = new Date();
            const diff = endDate - now;
            
            if (diff <= 0) {
                // 倒计时结束
                product.countdownText = '已结束';
                if (product.countdownTimer) {
                    clearInterval(product.countdownTimer);
                    product.countdownTimer = null;
                }
                // 确保视图更新
                this.$set(this.productList, index, { ...product });
                return;
            }
            
            // 精确计算剩余时间（精确到秒）
            const totalSeconds = Math.floor(diff / 1000);
            const days = Math.floor(totalSeconds / (3600 * 24));
            const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            
            // 格式化显示（精确到秒）
            let countdownText;
            if (days > 0) {
                countdownText = `${days}天${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            } else if (hours > 0) {
                countdownText = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            } else {
                countdownText = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }
            
            // 更新产品对象的倒计时文本
            product.countdownText = countdownText;
            
            // 使用Vue.set确保响应式更新
            this.$set(this.productList, index, { ...product });
        };
        
        // 立即执行一次更新
        updateCountdown();
        
        // 每秒更新一次（1000毫秒）
        const timerId = setInterval(updateCountdown, 1000);
        
        // 保存计时器ID到产品对象
        product.countdownTimer = timerId;
        
        // 保存到全局计时器数组
        this.countdownTimers.push(timerId);
    },
    
    // 获取结束时间（当天的23:59:59.999）
    getEndTime(dateString) {
        const date = new Date(dateString);
        // 设置为当天的最后一毫秒
        date.setHours(23, 59, 59, 999);
        return date;
    },
    
    // 清除所有计时器
    clearAllCountdowns() {
        // 清除所有计时器
        this.countdownTimers.forEach(timerId => {
            clearInterval(timerId);
        });
        this.countdownTimers = [];
        
        // 清除每个产品的计时器
        this.productList.forEach(product => {
            if (product.countdownTimer) {
                clearInterval(product.countdownTimer);
                product.countdownTimer = null;
                product.countdownText = null;
            }
        });
    },
    
    // 组件销毁时清除计时器
    beforeDestroy() {
        this.clearAllCountdowns();
    },

        handleReset() {
            this.searchForm = {
                name: '',
            }
            this.getProductList();
        },

        // 订单记录
        dingdanjilu() {
            // 这里实现订单记录的逻辑
            this.$router.push({ path: '/valueAddedService/orderHistory' });
        },
        buyProduct(item) {
            // 这里实现购买逻辑
            this.$router.push({ path: '/valueAddedService/transferVoucher', query: item });
        },
        pauseVideo(event) {
            const video = event.target;
            // 鼠标移入移出都暂停视频
            video.pause();
        },
        playVideo(url) {
            this.currentVideoUrl = url;
            this.videoVisible = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.navbox {
    width: 98%;
    margin: 0 auto;
}

// navbox的单数子元素加右边距
.navitem:nth-child(odd) {
    margin-right: 2%;
}

.navitem {
    width: 45%;
    display: inline-block;
    margin-top: 15px;
    font-size: 16px;
    font-weight: 500;
    position: relative;
}

.navitem_type {
    position: absolute;
    top: 0;
    left: 0;
}

.navitem_top {
    display: flex;
    padding: 15px;
    padding-top: 40px;
    background: var(--card-bg);
}

.navitem_bottom {
    padding: 15px;
    margin-top: 3px;
    background: var(--card-bg);
}

.navitem_video {
    width: 150px;
    height: 150px;
    background: var(--card-bg);
    display: flex;
    align-items: center;
    justify-content: center;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.navitem_info {
    flex: 1;
    padding-left: 10px;
}

.navitem_buy {
    width: 60px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    align-items: flex-end;
}

// 给文字加中横线
.line-through {
    text-decoration: line-through;
    color: var(--text-muted);
}

.aife {
    align-items: flex-end;
}

// 给内容前面加￥
.line-through::before {
    content: '￥';
}

.new_price {
    font-size: 24px;
    font-weight: 500;
    color: var(--danger);
}

.new_price::before {
    content: '￥';
}

.fcolo0065A3 {
    color: var(--accent);
    width: 95%;
    margin: 0 auto;
    padding-right: 20px;
    margin-bottom: 10px;
}

.navitem_bottom_text {
    width: 95%;
    margin: 0 auto;
    padding: 10px;
    border-radius: 4px;

    .content-wrapper {
        display: flex;
        align-items: flex-start;
        position: relative;

        .content-text {
            flex: 1;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; // 默认只显示1行
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5;
            transition: all 0.3s ease;

            &.show-full {
                -webkit-line-clamp: unset; // 显示所有行
                overflow: visible;
                display: block;
            }
        }

        .view-more-btn {
            font-size: 16px !important;
        }

        .view-more-btn,
        .view-less-btn {
            flex-shrink: 0;
            margin-left: 8px;
            color: var(--accent);
            font-size: 12px;
            padding: 0 4px;
            height: auto;

            &:hover {
                color: var(--accent);
            }
        }
    }
}

.detail-content {
    max-height: 400px;
    overflow-y: auto;
    padding: 15px;
    line-height: 1.6;
    word-break: break-word;
    background: var(--card-bg);
    border-radius: 4px;
    border: 1px solid var(--table-border);
}

.flex {
    display: flex;
}

.mgt-10 {
    margin-top: 10px;
}

.pdt-15 {
    padding-top: 15px;
}

.pdb-15 {
    padding-bottom: 15px;
}

.mgt-15 {
    margin-top: 15px;
}

.bg-white {
    background: var(--card-bg);
}

.navitem_type {
    width: 80px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background-color: #FF0000;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
}

.navitem_type_trial {
    background-color: #10CE00;
}

.custom-video {
    width: 100%;
    height: 100%;
    cursor: pointer;

    // 1. 去掉所有默认样式
    &::-webkit-media-controls-panel {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
    }

    // 2. 去掉控制条
    &::-webkit-media-controls {
        display: none !important;
    }

    // 3. 去掉播放按钮
    &::-webkit-media-controls-play-button {
        display: none !important;
    }

    // 4. 去掉进度条
    &::-webkit-media-controls-timeline {
        display: none !important;
    }

    // 5. 去掉音量控制
    &::-webkit-media-controls-volume-slider {
        display: none !important;
    }

    // 6. 去掉全屏按钮
    &::-webkit-media-controls-fullscreen-button {
        display: none !important;
    }

    // 7. 去掉鼠标悬停效果
    &:hover {

        &::-webkit-media-controls {
            display: none !important;
        }
    }

    // 8. 去掉焦点样式
    &:focus {
        outline: none;
    }

    // 9. 确保视频不自动播放
    &[autoplay] {
        display: none;
    }

    // 10. 通用浏览器样式重置
    &::-moz-media-controls-panel {
        display: none !important;
    }

    &::-moz-media-controls {
        display: none !important;
    }
}

.daojishi_time{
    font-size: 16px;
    font-weight: 500;
    color: var(--danger);
}
</style>